export default __webpack_public_path__ + "static/media/questionCircle.185228c8.svg";